import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useParams, Link } from "react-router-dom";

function Transaction() {

  const API_URL = process.env.REACT_APP_API_URL;

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(transactions);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 7;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredTransactions.slice(itemOffset, endOffset);
  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);
  const { id } = useParams();

  const handlePageChange = (event) => {
    const newOffset = (event.selected * itemsPerPage) % transactions.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/transactions/client/${id}`)
      .then((response) => {
        setTransactions(response.data);
        const temp = response.data.sort(
          (a, b) => new Date(b.datecreated) - new Date(a.datecreated)
        );
        setFilteredTransactions(temp);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, [id, API_URL]);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div className="w-11/12">
      <table className="w-full">
        <thead>
          <tr className="text-white font-semibold text-2xl w-3/4 border-2 border-collapse">
            <th>Date</th>
            <th>Service</th>
            <th>Amount</th>
            <th>Tip</th>
            <th>UserName</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((transaction) => (
            <tr
              key={transaction.id}
              className="text-wthie text-center w-4/5 text-2xl justify-center items-center xl:h-10 lg:h-14  border-2"
            >
              <td className="text-[#eed495]">
                {transaction.datecreated.split("T")[0]}
              </td>
              <td className="text-[#eed495]">{transaction.servicename}</td>
              <td className="text-[#eed495]">{transaction.amount}</td>
              <td className="text-[#eed495]">{transaction.tip}</td>
              <td className="text-[#eed495]">{transaction.username}</td>
              <td className="hover:text-[#eed495] text-6xl">
                <Link className="mx-4" to={`/transactions/${transaction.id}/edit`}>
                  &middot;&middot;&middot;
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        className="w-full flex justify-center text-center mt-10 text-3xl text-[#eed495]"
        disabledClassName="text-white"
        pageClassName="w-10"
        activeClassName="text-white"
        breakLabel="..."
        breakClassName=" w-10"
        nextLabel="Next"
        nextClassName=" w-18 ml-4"
        onPageChange={handlePageChange}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousClassName="t w-32 mr-4"
        previousLabel="Previous"
        renderOnZeroPageCount={null}
      />
    </div>
  );
}

export default Transaction;
